// Recovered compiled webpack factory 33407. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { LiquidMetalLogo: () => c });
  var a = r(95155),
    n = r(67909),
    l = r(12115),
    s = r(47850),
    i = r(87577);
  let d = (0, n.default)(
      () =>
        Promise.all([r.e(3432), r.e(7383)])
          .then(r.bind(r, 87383))
          .then((e) => e.LiquidMetal),
      { loadableGenerated: { webpack: () => [87383] }, ssr: !1 },
    ),
    o = "/ultramock-icon-white.svg";
  function c(e) {
    let { size: t = 132 } = e,
      r = (0, l.useRef)(null),
      n = (0, l.useRef)({ a: 70, x: 0, y: 0 }),
      c = (0, l.useRef)({ a: 70, x: 0, y: 0 }),
      u = (0, l.useRef)(0),
      [f, m] = (0, l.useState)({ a: 70, x: 0, y: 0 }),
      [p, x] = (0, l.useState)(1),
      [h, b] = (0, l.useState)(!1),
      g = (0, i.q)(r);
    ((0, l.useEffect)(() => {
      x(+!window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    }, []),
      (0, l.useEffect)(() => {
        let e = !0,
          t = new Image();
        return (
          (t.onload = () => {
            e && b(!0);
          }),
          (t.src = o),
          () => {
            e = !1;
          }
        );
      }, []));
    let y = () => {
      if (u.current) return;
      let e = () => {
        let t = n.current,
          r = c.current;
        if (
          ((r.a += (t.a - r.a) * 0.06),
          (r.x += (t.x - r.x) * 0.06),
          (r.y += (t.y - r.y) * 0.06),
          0.03 > Math.abs(t.a - r.a) && 5e-4 > Math.abs(t.x - r.x) && 5e-4 > Math.abs(t.y - r.y))
        ) {
          ((r.a = t.a), (r.x = t.x), (r.y = t.y), (u.current = 0), m({ a: r.a, x: r.x, y: r.y }));
          return;
        }
        (m({ a: r.a, x: r.x, y: r.y }), (u.current = requestAnimationFrame(e)));
      };
      u.current = requestAnimationFrame(e);
    };
    return (
      (0, l.useEffect)(() => () => cancelAnimationFrame(u.current), []),
      (0, a.jsxs)("div", {
        ref: r,
        onPointerMove: (e) => {
          let t = r.current;
          if (!t) return;
          let a = t.getBoundingClientRect(),
            l = Math.max(-1, Math.min(1, ((e.clientX - a.left) / a.width) * 2 - 1));
          ((n.current = {
            a: 70 + 28 * l,
            x: 0.07 * l,
            y: -(0.07 * Math.max(-1, Math.min(1, ((e.clientY - a.top) / a.height) * 2 - 1))),
          }),
            y());
        },
        onPointerLeave: () => {
          ((n.current = { a: 70, x: 0, y: 0 }), y());
        },
        className: "relative touch-none",
        style: { width: t, height: t },
        "aria-hidden": "true",
        children: [
          (0, a.jsx)("div", {
            className:
              "pointer-events-none absolute -inset-6 rounded-full bg-[radial-gradient(closest-side,rgba(120,120,140,0.22),transparent)] blur-md dark:bg-[radial-gradient(closest-side,rgba(200,210,255,0.18),transparent)]",
          }),
          h &&
            g &&
            (0, a.jsx)(s.E, {
              style: { width: t, height: t, position: "relative" },
              children: (0, a.jsx)(d, {
                image: o,
                width: t,
                height: t,
                colorBack: "#00000000",
                colorTint: "#ffffff",
                repetition: 3,
                softness: 0.32,
                shiftRed: 0.32,
                shiftBlue: 0.32,
                distortion: 0.1,
                contour: 0.55,
                scale: 0.74,
                speed: p,
                angle: f.a,
                offsetX: f.x,
                offsetY: f.y,
                style: { width: t, height: t, position: "relative" },
              }),
            }),
        ],
      })
    );
  }
}
